



var fullSiteRoot = 'https://hufworldwide.com';

// environment

hufConfig.fullSiteRoot = fullSiteRoot;

hufConfig.shopBaseURL = fullSiteRoot;


// general

hufConfig.colorOptionName = 'Color';

hufConfig.siteRegion = 'us';
hufConfig.currencyISO = 'USD';


// add to cart messages

hufConfig.qtyLowMessage = 'Only a few left, order quick!';
hufConfig.qtyLastMessage = 'Only one left, order quick!';
hufConfig.qtyLimitMessage = 'You have reached the quantity limit for this product.';


// geo

hufConfig.shopifyGeoDataURL = fullSiteRoot + '/browsing_context_suggestions.json';
hufConfig.ipStackGeoDataURL = 'https://api.ipstack.com/check?access_key=' + '58adea01e643cfe009402227675e55ad_xxx';


// algolia

hufConfig.algoliaAppId = 'AKTLZOI4B6';
hufConfig.algoliaAPIKey = '504bc5f781ecd3398b805e57e6f78fd8';

hufConfig.algoliaProductsIndex = 'huf_shopify_products';
hufConfig.algoliaProductsSortingIndexes = [
  ['Featured', hufConfig.algoliaProductsIndex],
  ['Price: High to Low', 'huf_shopify_products_high-to-low'],
  ['Price: Low to High', 'huf_shopify_products_low-to-high']
];
//hufConfig.algoliaCollectionsIndex = 'huf_shopify_collections';
//hufConfig.algoliaPagesIndex = 'huf_shopify_pages';
//hufConfig.algoliaArticlesIndex = 'huf_shopify_articles';

hufConfig.noSearchResultsMessage = 'Sorry, no matches found.';

hufConfig.separateAllListingProductsByColor = true;
hufConfig.separateListingProductsByColorTag = 'Separate Colors';


// klaviyo

hufConfig.klaviyoSiteId = 'VUAfvu';
hufConfig.klaviyoListId = 'XdW5Ei';


// payments

hufConfig.paymentOptionService = 'sezzle';


// sold out notify

hufConfig.notifyEmailEnabled = true;
//hufConfig.notifyPhoneEnabled = true;
//hufConfig.notifyDefaultMethod = 'phone';


// cart

hufConfig.cartAjaxEnabled = true;

hufConfig.fakeCartAjax = false;
hufConfig.cartDataBaseURL = fullSiteRoot;

hufConfig.miniCartCheckoutURL = fullSiteRoot + '/checkout';
hufConfig.miniCartViewCartURL = fullSiteRoot + '/cart';


// urls

hufConfig.collectionURL = fullSiteRoot + '/collections/{collection_slug}';
hufConfig.collectionProductURL = fullSiteRoot + '/collections/{collection_slug}/products/{product_slug}';
hufConfig.productURL = fullSiteRoot + '/products/{product_slug}';
hufConfig.pageURL = fullSiteRoot + '/pages/{page_slug}';
hufConfig.articleURL = fullSiteRoot + '/blogs/{blog_slug}/{article_slug}';

// store locator map

hufConfig.mapStyles = ( // generate using https://snazzymaps.com/editor
  [
      {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "color": "#444444"
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#f2f2f2"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 45
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#e1e1e1"
              },
              {
                  "visibility": "on"
              }
          ]
      }
  ]
);